import { apiAddress } from "../../config/server";
import { ApiBase } from "./baseApi";


export default class QueueApi extends ApiBase {
    static ApiAddress = `${apiAddress}/api/queue/`;

    static getStatus(): Promise<string> {
        return this.get<string>(this.ApiAddress + 'status')
            .then((response) => response.data.data);
    }

    static purge(): Promise<string> {
        return this.delete<string>(this.ApiAddress)
            .then((response) => response.data.data);
    }
}
